export default __webpack_public_path__ + "99f5ae1f593cc167d2c6b39c1eb78a91.png";